/**
 * Per-user chat DISPLAY preferences: allowlists, defaults, and the font-size
 * scale. Shared by App.js (state + hydration), ChatPanel.js (rendering), and
 * ProfileDialog.js (the controls) so the valid values live in exactly one
 * place. The allowlists mirror the backend validators in
 * backend/src/services/socketService.js (set-font-size / set-timestamp-format /
 * set-mention-volume).
 */

// ---- Font size --------------------------------------------------------------
// Stored as a percentage string of the base message-text size. '100' is the
// historical 0.875rem, so existing users see no change by default. Stored as
// strings (not numbers) to match the other string-valued prefs and the socket
// allowlist.
export const FONT_SIZES = ['50', '80', '100', '120', '150', '200'];
export const DEFAULT_FONT_SIZE = '100';

// Base message-text size (the historical hardcoded value) that the percentages
// scale. Kept in rem so it still tracks the root font size.
const FONT_SIZE_BASE_REM = 0.875;

// Maps a font-size percentage preference to the message-text rem value applied
// in ChatPanel (e.g. '150' → 1.3125rem). Unknown/legacy values fall back to the
// default so old 'small|medium|large' rows render at 100% rather than breaking.
export const fontSizeRem = (size) => {
  const pct = FONT_SIZES.includes(size) ? Number(size) : Number(DEFAULT_FONT_SIZE);
  return `${(FONT_SIZE_BASE_REM * pct) / 100}rem`;
};

// ---- Timestamp format -------------------------------------------------------
// 'relative' -> "2m ago"; 'clock' -> locale time (historical default);
// 'off' -> hidden inline, revealed on hover / long-press.
export const TIMESTAMP_FORMATS = ['relative', 'clock', 'off'];
export const DEFAULT_TIMESTAMP_FORMAT = 'clock';

// ---- Mention-sound volume ---------------------------------------------------
export const DEFAULT_MENTION_VOLUME = 60; // 0-100

// Clamp any input to a valid integer volume; falls back to the default for
// non-finite input.
export const clampVolume = (v) => {
  const n = Math.round(Number(v));
  if (!Number.isFinite(n)) return DEFAULT_MENTION_VOLUME;
  return Math.min(100, Math.max(0, n));
};
